var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 58,
    viewBox: "0 0 62 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7068_2868)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.4714,
    height: 50.0553,
    rx: 25.0276,
    fill: "#E5E5E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7068_2868)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.565 12.4919C23.4307 11.5744 20.9788 13.1276 20.9788 15.4959V22.0564C20.9788 26.8574 24.2659 30.873 28.6636 31.8766C29.4215 32.1616 29.6545 32.545 29.6845 32.8506V32.917V32.9214V32.9815C29.6765 33.1705 29.5943 33.4272 29.3652 33.6349H26.9557C26.3644 33.6349 25.8852 34.1142 25.8852 34.7054C25.8852 34.8258 25.9051 34.9416 25.9417 35.0496H24.7636C24.1704 35.0496 23.6894 35.5305 23.6894 36.1239C23.6894 36.7172 24.1704 37.1981 24.7636 37.1981H36.5701C37.1634 37.1981 37.6444 36.7172 37.6444 36.1239C37.6444 35.5305 37.1634 35.0496 36.5701 35.0496H35.5961C35.6327 34.9416 35.6526 34.8258 35.6526 34.7054C35.6526 34.1142 35.1733 33.6349 34.5821 33.6349H32.138C31.9264 33.4677 31.8181 33.262 31.7761 33.0846V32.8728C31.8343 32.529 32.1574 32.1033 33.1701 31.8277C37.465 30.7481 40.6508 26.7828 40.6508 22.0564V15.4959C40.6508 13.1276 38.1989 11.5744 36.0646 12.4919C34.0744 13.3475 31.9439 14.1308 30.8148 14.1308C29.6857 14.1308 27.5552 13.3475 25.565 12.4919ZM18.2626 24.2807C16.9667 23.5994 16.2617 22.086 16.6503 20.6161C16.7301 20.314 17.0391 20.1367 17.3403 20.22L17.4449 20.2489C18.3453 20.498 19.0517 21.112 19.4475 21.8877C19.7087 22.0396 19.8823 22.3243 19.877 22.6479C19.8647 23.3994 19.9882 24.6802 20.4065 25.986C20.8266 27.2971 21.5142 28.542 22.5641 29.3411C22.9432 29.6295 23.0165 30.1707 22.7281 30.5497C22.6646 30.633 22.589 30.7016 22.5056 30.7548C21.7921 32.1327 20.1499 32.775 18.6653 32.1954C18.3795 32.0839 18.2347 31.7604 18.3419 31.4728L18.4283 31.2413C18.7554 30.3643 19.4331 29.7276 20.2412 29.4297C20.0098 29.128 19.8033 28.8119 19.6191 28.4881C18.1956 28.7554 16.7409 28.0017 16.1675 26.601C16.0493 26.3123 16.186 25.9787 16.4727 25.8558L16.5854 25.8076C17.222 25.535 17.895 25.4883 18.517 25.6317C18.4034 25.1623 18.3205 24.7063 18.2626 24.2807ZM41.7115 21.934C41.4906 22.0935 41.3486 22.3548 41.3534 22.6479C41.3656 23.3994 41.2422 24.6802 40.8238 25.986C40.4038 27.2971 39.7162 28.542 38.6662 29.3411C38.2872 29.6295 38.2138 30.1707 38.5023 30.5497C38.5763 30.647 38.667 30.7242 38.7673 30.7802C39.4877 32.1405 41.1189 32.7714 42.5943 32.1954C42.8801 32.0839 43.0249 31.7604 42.9177 31.4728L42.8313 31.2413C42.5011 30.3561 41.8137 29.7156 40.9956 29.4213C41.2339 29.1096 41.4459 28.7826 41.6341 28.4478C43.1144 28.8192 44.6717 28.0622 45.2698 26.601C45.388 26.3123 45.2514 25.9787 44.9646 25.8558L44.8519 25.8076C44.139 25.5022 43.3804 25.4803 42.6988 25.6915C42.8248 25.1813 42.9145 24.686 42.975 24.2272C44.2798 23.5026 44.9454 21.9316 44.4851 20.4572C44.392 20.159 44.0759 19.996 43.779 20.0929L43.6718 20.128C42.7555 20.4273 42.0626 21.1057 41.7115 21.934Z",
    fill: "#AFAFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7068_2868",
    x: 0,
    y: 0,
    width: 61.4712,
    height: 57.0805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.0253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7068_2868"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.0253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7068_2868",
    result: "effect2_dropShadow_7068_2868"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7068_2868",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7068_2868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 25.5,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastLevel);
export default __webpack_public_path__ + "static/media/LastLevel.a6f1c25b61b3b4e801a77629c28c05e3.svg";
export { ForwardRef as ReactComponent };